import './FrameHeader.css';

type FrameHeaderProps = {
  /** Visibility of sub_header_background (118:6772). Default: true. */
  showSubHeader?: boolean;
};

/** From Figma header (119:6946) — sub_header + header_background. */
export function FrameHeader({ showSubHeader = true }: FrameHeaderProps) {
  return (
    <div
      className={['frame-header', showSubHeader ? 'frame-header--with-sub' : '']
        .filter(Boolean)
        .join(' ')}
      aria-hidden
    />
  );
}
